import Router from "@/Router";
import { BrowserRouter } from "react-router-dom";
import { MotionConfig } from "motion/react";
import Toaster from "@/Components/Toast";

const App = () => {
  return (
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <Router />
        <Toaster />
      </BrowserRouter>
    </MotionConfig>
  );
};

export default App;
